<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="600px"
      :innerScroll="false"
      :loading="loadingButtom"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <div style="position: relative">
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" size="small" inline class="content">
          <el-form-item label="SKU编码:">
            <div style="width: 170px">{{ addForm.skuCode }}</div>
          </el-form-item>
          <el-form-item label="SKU名称:" class="tipsText">
            <el-tooltip class="item" effect="dark" :content="addForm.skuName" placement="top" v-if="addForm.skuName && addForm.skuName.length >= 20">
              <div class="tips">{{addForm.skuName}}</div>
            </el-tooltip>
            <span v-else>{{ addForm.skuName }}</span>
          </el-form-item>
          <el-form-item label="产品编码:">
            <div style="width: 170px">{{ addForm.productCode }}</div>
          </el-form-item>
          <el-form-item label="产品名称:" class="tipsText">
            <el-tooltip class="item" effect="dark" :content="addForm.productName" placement="top" v-if="addForm.productName && addForm.productName.length >= 15">
              <div class="tips">{{addForm.productName}}</div>
            </el-tooltip>
            <span v-else>{{ addForm.productName }}</span>
          </el-form-item>
          <el-form-item label="类型:" prop="dataType">
            <el-select v-model="addForm.dataType" placeholder="请选择" filterable disabled>
              <el-option v-for="item in ['拍摄','渲染']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="item.displayName + ':'" v-for="(item,index) in formList" :key="index">
            <el-input v-model="addForm[item.propertyName]" @input="addForm[item.propertyName]=addForm[item.propertyName].replace(/^0+(\d)|[^\d]+/g,'')" :disabled="addForm.dataType == '渲染' && item.displayName != '常规产品'"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </q-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import E from "wangeditor";
import imgShow from "@/views/components/imgShow";
import axios from "@/utils/axiosInstance";
import { getToken } from "@/utils/auth";
export default {
  name: "CRUDEdit",
  components: { imgShow },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // storeListEdit: {
    //   type: Array,
    //   default: [],
    // },
    // 1新增，2编辑，3审核
    dialogType: {
      type: Number,
      default: 1,
    },
    columnData: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "编辑";
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  data() {
    return {
      loadingButtom: false,
      loading: false,
      error: false,
      imgFormVisible: false,
      sumNumber: 0,
      isShowTable: true,
      addForm: {
        registerDate: moment(new Date()).format("YYYY-MM-DD"),
        refundReason: [],
        screenshotList: [],
        weekNum: moment().format("W"),
        registerMonth: moment().month() + 1,
      },
      rules: {
        dataType: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      textForm: {},
      serviceUserIdList: [],
      skuCodeList: [],
      imgList: [],
      columnList: [],
      formList: []
    };
  },
  mounted() {
    this.formList = this.columnData.slice(8,this.columnData.length)
    if (this.rowData) {
      this.addForm = this.rowData;
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          configMap: this.addForm,
        };
        this.$q.dataImport.shootingTypeUpdate({data: data})
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
  },
  created() {},
};
</script>

<style lang="stylus" scoped>

.content {
  max-height: 70vh
  overflow-y: auto
}

>>> .el-form-item {
  margin-bottom: 18px
}

>>> .el-dialog {
  margin: 50px auto !important
}

>>> .el-input--small .el-input__inner, >>> .el-input--suffix .el-input__inner, >>> .el-input--suffix {
  height: 32px;
  line-height: 32px;
  width: 170px !important;
}

>>> .el-date-editor.el-input {
  width: 170px
}

>>> .el-select .el-input .el-select__caret {
  height: 32px;
  line-height: 32px;
}

>>> .el-textarea .el-input__count {
    background: transparent;
    height: 28px;
}

.tipsText >>> .el-form-item__content {
  width: 450px
}

.tips {
  width: 100%
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


</style>
